import { AxiosRequestConfig } from 'axios';
import { mapToData } from 'src/common/http/mapToData';
import { mapToErrors } from 'src/common/http/mapToErrors';

import instance from '../../../common/http/axiosInstance';
import {
  AffiliateListParams,
  AffiliateStats,
  AffiliateStatsParams,
  GlobalBreakdownParams,
  GlobalBreakdownResponse,
  ReferralTreeNode,
  StatsBreakdownEntry,
  StatsBreakdownParams,
  TotalStats,
} from '../domain/types';

export type AffiliateTotalStatsParams = Pick<
  AffiliateListParams,
  'statuses' | 'regions' | 'tiers' | 'dateRange' | 'dateFrom' | 'dateTo'
>;

const requests = {
  get: async <T>(url: string, config?: AxiosRequestConfig): Promise<T> =>
    instance
      .get(url, config)
      .then(mapToData)
      .catch((err) => {
        if (err.response?.status === 404) {
          return null;
        }

        return mapToErrors(err);
      }),
};

export const affiliateStatsService = {
  getStats: async (projectId: string, params: AffiliateStatsParams): Promise<AffiliateStats> =>
    requests.get<AffiliateStats>(`projects/${projectId}/affiliate-portal/stats`, { params }),

  getTotalStats: async (projectId: string, params?: AffiliateTotalStatsParams): Promise<TotalStats> =>
    requests.get<TotalStats>(`projects/${projectId}/affiliate-portal/total-stats`, { params }),

  getStatsBreakdown: async (projectId: string, params: StatsBreakdownParams): Promise<StatsBreakdownEntry[]> =>
    requests
      .get<{ results: StatsBreakdownEntry[] }>(`projects/${projectId}/affiliate-portal/stats-breakdown`, { params })
      .then((res) => res?.results ?? []),

  getReferralTree: async (projectId: string, params: AffiliateStatsParams): Promise<ReferralTreeNode> =>
    requests.get<ReferralTreeNode>(`projects/${projectId}/affiliate-portal/referral-tree`, { params }),

  getGlobalBreakdown: async (projectId: string, params: GlobalBreakdownParams): Promise<GlobalBreakdownResponse> =>
    requests.get<GlobalBreakdownResponse>(`projects/${projectId}/affiliate-portal/global-breakdown`, { params }),
};
